import { DEFAULT_PHOTO_TYPE_TITLES } from "@/src/store/apis/photoType/interface";
import { PhotoTypeMediaInfo } from "@/src/store/apis/tasks/taskDetail/interface";
import { TaskPhotoTypeRequestResponseDto } from "@/src/store/apis/tasks/taskRegister/interface";

/**
 * 커스텀 사진 타입인지 확인
 */
export const isCustomPhotoType = (typeCode: string): boolean => {
  return typeCode.startsWith("CUSTOM_") || typeCode.startsWith("custom");
};

/**
 * 다운로드용 사진 타입 제목 결정
 *
 * 우선순위:
 * 1. photoTypeMedias.title (최신 데이터)
 * 2. photoTypeRequests.title (스냅샷 데이터)
 * 3. DEFAULT_PHOTO_TYPE_TITLES (기본 타입 제목)
 * 4. typeCode (fallback)
 */
export const getPhotoTypeTitleForDownload = (
  typeCode: string,
  photoTypeRequests?: TaskPhotoTypeRequestResponseDto[],
  photoTypeMedias?: Record<string, PhotoTypeMediaInfo>
): string => {
  // 1. photoTypeMedias에서 title 확인 (최신 데이터)
  const mediaInfo = photoTypeMedias?.[typeCode];
  if (mediaInfo?.title) {
    return mediaInfo.title;
  }

  // 2. photoTypeRequests에서 title 확인 (스냅샷 데이터)
  const request = photoTypeRequests?.find((req) => req.typeCode === typeCode);
  if (request?.title) {
    return request.title;
  }

  // 3. 기본 타입 제목 확인
  if (DEFAULT_PHOTO_TYPE_TITLES[typeCode as keyof typeof DEFAULT_PHOTO_TYPE_TITLES]) {
    return DEFAULT_PHOTO_TYPE_TITLES[typeCode as keyof typeof DEFAULT_PHOTO_TYPE_TITLES];
  }

  // 4. typeCode 그대로 반환
  return typeCode;
};
